import React from 'react';
import Layout from './Layout';
import {Route} from 'react-router'


export default class RouterLayout extends React.Component {
    render() {
        let {component: Component, children, ...rest} = this.props;
        return <Layout {...this.props}>
            <Component {...rest} />
        </Layout>
    }
}



